import { render, staticRenderFns } from "./basic-form.vue?vue&type=template&id=5f638e17&scoped=true&"
import script from "./basic-form.vue?vue&type=script&lang=js&"
export * from "./basic-form.vue?vue&type=script&lang=js&"
import style0 from "./basic-form.vue?vue&type=style&index=0&id=5f638e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f638e17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5f638e17', component.options)
    } else {
      api.reload('5f638e17', component.options)
    }
    module.hot.accept("./basic-form.vue?vue&type=template&id=5f638e17&scoped=true&", function () {
      api.rerender('5f638e17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/product-forms/basic-form.vue"
export default component.exports